module.exports = __webpack_public_path__ + "h5/img/live-logo.e8c55ecf.gif";